import { useState } from "react";
import { useTranslation } from "./i18n";

const studentKeys = [
  "sampleStudent1",
  "sampleStudent2",
  "sampleStudent3",
  "sampleStudent4",
  "sampleStudent5",
  "sampleStudent6",
] as const;

export default function LandingRecordDemo() {
  const { t } = useTranslation("landing");
  // This illustration stays in React memory: it never opens a classroom store.
  const [answers, setAnswers] = useState(() => studentKeys.map(() => 0));
  const [state, setState] = useState<"ready" | "saved">("ready");
  const total = answers.reduce((sum, count) => sum + count, 0);

  return (
    <section className="marketing-record-demo" aria-label={t("recordDemoLabel")}>
      <div className="marketing-demo-topline">
        <span className="marketing-demo-brand">{t("recordDemoClass")}</span>
        <span className="marketing-demo-badge">{t("recordDemoBadge")}</span>
      </div>
      <div className="marketing-demo-heading">
        <p>{t("recordDemoInstruction")}</p>
      </div>
      <div className="marketing-demo-blackboard">{t("recordDemoBlackboard")}</div>
      <div className="marketing-demo-seats">
        {studentKeys.map((key, index) => (
          <button
            type="button"
            className={`marketing-demo-seat${answers[index] > 0 ? " marketing-demo-seat-recorded" : ""}`}
            key={key}
            aria-label={t("recordDemoAnswer", { number: index + 1, name: t(key) })}
            onClick={() => {
              setAnswers((current) => current.map((count, seat) => (seat === index ? count + 1 : count)));
              setState("saved");
            }}
          >
            <span className="marketing-demo-number">{t("recordDemoNumber", { number: index + 1 })}</span>
            <b>{t(key)}</b>
            <span className="marketing-demo-count">{t("recordDemoCount", { count: answers[index] })}</span>
            <span className="marketing-demo-plus" aria-hidden="true">
              ＋
            </span>
          </button>
        ))}
      </div>
      <div className="marketing-demo-savebar">
        <b>{t("recordDemoTotal", { count: total })}</b>
      </div>
      <p className="marketing-demo-status" role="status">
        {t(state === "saved" ? "recordDemoSaved" : "recordDemoReady")}
      </p>
      <div className="marketing-demo-footer">
        <span>{t("recordDemoNotice")}</span>
        <button
          type="button"
          onClick={() => {
            setAnswers(studentKeys.map(() => 0));
            setState("ready");
          }}
        >
          {t("recordDemoReset")}
        </button>
      </div>
    </section>
  );
}
